import { render, staticRenderFns } from "./OfertasParticulares.vue?vue&type=template&id=c0fa0248&"
import script from "./OfertasParticulares.vue?vue&type=script&lang=js&"
export * from "./OfertasParticulares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports